import { createContext } from 'react';

import noop from 'lodash/noop';

import { ComboboxContextValue } from './types';

const ComboboxContext = createContext<ComboboxContextValue>({
  open: false,
  query: '',
  options: [],
  setQuery: noop,
});

export default ComboboxContext;
